/** URL segment of the default REVOO customer placeholder image (encoded space in path). */
export const REVOO_DEFAULT_CUSTOMER_AVATAR_URL_MARKER =
  "foto%20avatar%20REVOO.png";

/**
 * Returns `undefined` when there is no usable photo so the avatar shows initials.
 */
export function resolveCustomerAvatarSrc(
  imageUrl: string | null | undefined,
): string | undefined {
  if (!imageUrl || typeof imageUrl !== "string") return undefined;
  if (imageUrl.includes(REVOO_DEFAULT_CUSTOMER_AVATAR_URL_MARKER)) {
    return undefined;
  }
  return imageUrl;
}

/**
 * Extracts initials from a name for Avatar display.
 * Filters out emoji-only "words" when splitting by space, so names like
 * "Chat ❤️ 02 ❤️" yield "C0" instead of "C❤".
 */
export function getInitialsForAvatar(name: string): string {
  const words = name.split(/\s+/).filter((w) => /^[a-zA-Z0-9]/.test(w));
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}
